// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id';

// Google OAuth configuration object
export const googleOAuthConfig = {
    clientId: GOOGLE_CLIENT_ID,
    scope: 'email profile',
    access_type: 'offline',
    include_granted_scopes: true
};

// Google OAuth scopes
export const GOOGLE_SCOPES = [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile'
].join(' ');

// Google OAuth endpoints
export const GOOGLE_ENDPOINTS = {
    AUTH: 'https://accounts.google.com/o/oauth2/v2/auth',
    TOKEN: 'https://oauth2.googleapis.com/token',
    USER_INFO: 'https://www.googleapis.com/oauth2/v2/userinfo'
}; 